import { render, staticRenderFns } from "./appAddresses.vue?vue&type=template&id=1b3e3a14&scoped=true&"
import script from "./appAddresses.vue?vue&type=script&lang=js&"
export * from "./appAddresses.vue?vue&type=script&lang=js&"
import style0 from "./appAddresses.vue?vue&type=style&index=0&id=1b3e3a14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3e3a14",
  null
  
)

export default component.exports